import type {
  CommentableContentType,
  CommentContentType,
  CommentHighlightParams,
  DetailPolicyVersionSerializedType,
  ProcedureVersionSerializedType,
  ProcessVersionSerializedType,
} from 'sweet-types';

export type FilterContentType =
  | 'procedure'
  | 'taskinstance'
  | 'quiz'
  | 'policy'
  | 'proceduregroup';

export type TextHighlightType = {
  id: string;
  startParams: CommentHighlightParams;
  endParams: CommentHighlightParams;
  versionId: number;
  contentType: CommentableContentType;
  selectedText: string;
  color: string;
  colorLight: string;
  stepId: string;
};

export type InlineCommentVersionType =
  | DetailPolicyVersionSerializedType
  | ProcedureVersionSerializedType
  | ProcessVersionSerializedType;

export const translateCommentContentType = (
  contentType: CommentableContentType
): CommentContentType => {
  const data: Record<CommentableContentType, CommentContentType> = {
    procedureversion: 'procedure',
    policyversion: 'policy',
    processversion: 'proceduregroup',
    quizversion: 'quiz',
    taskinstance: 'taskinstance',
  };
  return data[contentType];
};
